export type DisplayVariant = 'regular' | 'circular';

const displayVariant: { [key: string]: DisplayVariant } = {
  REGULAR: 'regular',
  CIRCULAR: 'circular',
};

export default displayVariant;
